import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, QrCodeModal, ShareCard, ShareItems } from 'ui';
import { type ShareAction, useNetworkShareItems } from './hooks';

type P = {
  card?: boolean;
  emailOnlyText?: boolean;
  entityName: string;
  path: string;
  subject?: string;
  text?: string;
};

const NetworkShare = ({ card = true, emailOnlyText, entityName, path, subject, text }: P) => {
  const { t } = useTranslation();

  const sharedContent = `${window.location.origin}${path}`;

  const [isQrCodeVisible, setIsQrCodeVisible] = useState(false);

  const fileName = t('shareQrCodeEntityName', { entityName });

  const actions = useMemo(
    () =>
      [
        { icon: <Icon icon="link-line" />, key: 'copy', label: 'Copy link', type: 'copy' },
        {
          icon: <Icon icon="qrcode-line" />,
          key: 'qr-code',
          label: 'QR code',
          onClick() {
            setIsQrCodeVisible(true);
          },
          type: 'qr-code',
        },
        {
          icon: <Icon icon="mail-send-line" />,
          key: 'email',
          label: 'Email',
          socialNetwork: 'email',
          type: 'social',
        },
        {
          icon: <Icon icon="linkedin" />,
          key: 'linkedin',
          label: 'LinkedIn',
          socialNetwork: 'linkedin',
          type: 'social',
        },
        {
          icon: <Icon icon="fb" />,
          key: 'facebook',
          label: 'Facebook',
          socialNetwork: 'facebook',
          type: 'social',
        },
      ] satisfies ShareAction[],
    [],
  );

  const items = useNetworkShareItems({ actions, emailOnlyText, sharedContent, subject, text });

  return (
    <>
      {card ? <ShareCard shareItems={{ items, itemsPerRow: 3 }} /> : <ShareItems items={items} itemsPerRow={3} />}
      <QrCodeModal
        alerts={[
          {
            description:
              'You can display the QR code for someone nearby, share it through messaging apps, or download it to your device for later use',
          },
        ]}
        fileName={fileName}
        isOpened={isQrCodeVisible}
        onCancel={() => {
          setIsQrCodeVisible(false);
        }}
        qrCodeValue={sharedContent}
        title="Share via QR code"
      />
    </>
  );
};

export default NetworkShare;
